define(function (require) {
    'use strict';
    var defineComponent = require('flightjs').component;
    return defineComponent(BugReporter);

    function BugReporter() {
        this.attributes({
            'cardNameAttr': 'data-bug-report-card-name',
            'listIdAttr': 'data-bug-report-list-id',
            'reportActionTrigger': '[data-bug-report-action]',
            'reportWindowOffsetTop': 370,
            'reportWindowOffsetLeft': 250,
            'reportWindowWidth': 500,
            'reportWindowHeight': 600,
        });

        this.after('initialize', function () {
            this.on('click', {
                reportActionTrigger: this.openCreateCardWindow
            });
        });

        this.openCreateCardWindow = function () {
            var listId = this.$node.attr(this.attr.listIdAttr) || '56e8e2aee74a708f2bab8641';
            var cardName = this.$node.attr(this.attr.cardNameAttr) || 'Bug report';
            var reportWindowProps = '';
            var reportWindowName = 'add-trello-card';
            var reportWindowURL = 'https://trello.com/add-card?';

            reportWindowURL += 'source=' + encodeURIComponent(window.location.href);
            reportWindowURL += '&mode=popup';
            reportWindowURL += '&url=' + encodeURIComponent(window.location.href);
            reportWindowURL += '&name=' + encodeURIComponent(cardName);
            reportWindowURL += '&idList=' + listId;

            reportWindowProps += 'width=' + this.attr.reportWindowWidth;
            reportWindowProps += ',height=' + this.attr.reportWindowWidth;
            reportWindowProps += ',left=' + (window.screenX + window.outerWidth / 2 - this.attr.reportWindowOffsetLeft);
            reportWindowProps += ',top=' + (window.screenY + window.outerHeight / 2 - this.attr.reportWindowOffsetTop);


            window.open(reportWindowURL, reportWindowName, reportWindowProps);
        };
    }
});



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/ui/bug-reporter.js
 **/